// import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'

import { STATSIG_EXPERIMENTS } from './statsig-experiments.config'
export const SERVER_EXPERIMENTS_CONFIG: Partial<Record<STATSIG_EXPERIMENTS, string[]>> = {}

export const SERVER_CUSTOM_EXPERIMENTS = {
  home_page: new Set(['/', '/New-home-design', '/new-home-page']),
}

export const SERVER_EXPERIMENTS_URL_LOOKUP: Map<string, string[]> = getUrlExperimentLookup(SERVER_EXPERIMENTS_CONFIG)

function getUrlExperimentLookup(exp_urls_map: Record<string, string[]>): Map<string, string[]> {
  const map = new Map<string, string[]>()
  Object.entries(exp_urls_map).forEach(([expName, urls]) => {
    urls.forEach(url => {
      if (map.has(url)) {
        map.get(url)?.push(expName)
      } else {
        map.set(url, [expName])
      }
    })
  })
  return map
}
